export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";